"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _domLib = require("dom-lib");

var _utils = require("../utils");

var DropdownMenuGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(DropdownMenuGroup, _React$Component);

  function DropdownMenuGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "DropdownMenuGroup", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickGroup", function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          classPrefix = _this$props.classPrefix;
      (0, _domLib.toggleClass)(_this.DropdownMenuGroup, classPrefix + "-closed");
      onClick && onClick(event);
    });
    return _this;
  }

  var _proto = DropdownMenuGroup.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        title = _this$props2.title,
        children = _this$props2.children,
        classPrefix = _this$props2.classPrefix,
        className = _this$props2.className,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props2, ["title", "children", "classPrefix", "className"]);
    var addPrefix = (0, _utils.prefix)(classPrefix);
    var classes = (0, _classnames.default)(classPrefix, className);
    var unhandled = (0, _utils.getUnhandledProps)(DropdownMenuGroup, rest);
    return React.createElement("li", (0, _extends2.default)({}, unhandled, {
      className: classes,
      ref: function ref(_ref) {
        _this2.DropdownMenuGroup = _ref;
      }
    }), React.createElement("div", {
      className: addPrefix('title'),
      role: "menuitem",
      tabIndex: -1,
      onClick: this.handleClickGroup
    }, React.createElement("span", null, title), React.createElement("span", {
      className: addPrefix('caret')
    })), React.createElement("ul", {
      className: addPrefix('children')
    }, children));
  };

  return DropdownMenuGroup;
}(React.Component);

(0, _defineProperty2.default)(DropdownMenuGroup, "defaultProps", {
  classPrefix: 'dropdown-menu-group'
});
(0, _defineProperty2.default)(DropdownMenuGroup, "handledProps", ["children", "className", "classPrefix", "onClick", "title"]);
var _default = DropdownMenuGroup;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/lib/_picker/DropdownMenuGroup.js
// module id = 575
// module chunks = 0